import { auth } from '@learnics/services/src/analyticsConfig'
import { customOauthLoginWithPopup } from '@/utils/gapi/customOauthLoginWithPopup'
import Oauth2Service from '@learnics/services/src/oauth2'

export async function authorizeOauthScopes(providerId, scopes, showWarning) {
  console.log('Authorizing oauth scopes:', scopes)
  const uid = auth.currentUser?.uid
  let storageKey = `oauth2Tokens/${uid}`
  let authTokens = uid && JSON.parse(localStorage.getItem(storageKey) || '{}')
  const { missingScopes, token } = await Oauth2Service.validateTokenForScopes(
    providerId,
    scopes,
    uid,
    authTokens?.[providerId],
  )

  if (token) {
    authTokens[providerId] = token
    localStorage.setItem(storageKey, JSON.stringify(authTokens))
  }

  if (!token) {
    missingScopes.push(...scopes)
  }

  if (missingScopes.length === 0) {
    return token
  }

  const loginResult = await customOauthLoginWithPopup(
    {},
    providerId,
    auth.currentUser,
    scopes,
    undefined,
    undefined,
    showWarning,
  )
  const tokens = loginResult.tokens
  if (tokens) {
    authTokens = JSON.parse(localStorage.getItem(storageKey) || '{}')
    authTokens[providerId] = tokens
    localStorage.setItem(storageKey, JSON.stringify(authTokens))
    return tokens
  } else {
    console.log('Failed to authorize scopes:', loginResult)
    throw new Error('Failed to authorize scopes')
  }
}
